import React from "react";
import TOUR_IMG from "../../img/consult_tour.gif";

export default function tourDashboard(t, i18n) {
  return [
    {
      selector: '[data-tut="step_one_tour"]',
      content: ({ goTo, skipHandler }) => (
        <div
          dir={i18n.dir()}
          style={{
            marginRight: i18n.dir() === "rtl" ? "10px" : "0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="tour-title"
          >
            <h4
              style={{
                color: "#fff",
                fontSize: "18px",
                fontWeight: "700",
                lineHeight: "22px",
                marginBottom: "12px",
              }}
            >
              {t("tour.firstStepTitle")}
            </h4>
          </div>
          <p
            style={{
              color: "#fff",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              marginBottom: "16px",
            }}
          >
            {t("tour.firstStepOverviewText")}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p
              style={{
                color: "#fff",
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "17px",
              }}
            >
              {t("stepText", {currentStep: 1, endStep: 3, ns: "common"})}
            </p>
            <div
              style={{
                display: "flex",
              }}
            >
              <button
                className="tour-next"
                style={{
                  background: "#00508E",
                  padding: "8px 32px",
                  borderRadius: "5px",
                  fontSize: "14px",
                  display: "block",
                  cursor: "pointer",
                  border: "0",
                  color: "#fff",
                }}
                onClick={() => goTo(1)}
              >
                {t("tour.nextButtonLabel")}
              </button>
            </div>
          </div>
        </div>
      ),
      style: {
        padding: "24px 32px",
        maxWidth: "407px",
        background: "#003F75",
        height: "170px",
      },
    },
    {
      selector: '[data-tut="step_two_tour"]',
      content: ({ goTo }) => (
        <div
          dir={i18n.dir()}
          style={{
            marginRight: i18n.dir() === "rtl" ? "10px" : "0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="tour-title"
          >
            <h4
              style={{
                color: "#fff",
                fontSize: "18px",
                fontWeight: "700",
                lineHeight: "22px",
                marginBottom: "12px",
              }}
            >
              {t("tour.secondStepTitle")}
            </h4>
          </div>
          <p
            style={{
              color: "#fff",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              marginBottom: "16px",
            }}
          >
            {t("tour.secondStepOverviewText")}
          </p>
          <img
            style={{
              width: "100%",
              height: "100px",
              marginBottom: "16PX",
            }}
            src={TOUR_IMG}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p
              style={{
                color: "#fff",
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "17px",
              }}
            >
              {t("stepText", {currentStep: 2, endStep: 3, ns: "common"})}
            </p>
            <div
              style={{
                display: "flex",
              }}
            >
              <button
                className="tour-prev"
                style={{
                  background: "#00508E",
                  padding: "8px 32px",
                  borderRadius: "5px",
                  fontSize: "14px",
                  display: "block",
                  cursor: "pointer",
                  border: "0",
                  color: "#fff",
                  marginRight: i18n.dir() === "rtl" ? "0" : "8px",
                  marginLeft: i18n.dir() === "rtl" ? "8px" : "0",
                }}
                onClick={() => goTo(0)}
              >
                {t("tour.previousButtonLabel")}
              </button>
              <button
                className="tour-next"
                style={{
                  background: "#00508E",
                  padding: "8px 32px",
                  borderRadius: "5px",
                  fontSize: "14px",
                  display: "block",
                  cursor: "pointer",
                  border: "0",
                  color: "#fff",
                }}
                onClick={() => goTo(2)}
              >
                {t("tour.nextButtonLabel")}
              </button>
            </div>
          </div>
        </div>
      ),
      style: {
        padding: "24px 32px",
        maxWidth: "407px",
        background: "#003F75",
      },
    },
    {
      selector: '[data-tut="step_three_tour"]',
      content: ({ goTo }) => (
        <div
          dir={i18n.dir()}
          style={{
            marginRight: i18n.dir() === "rtl" ? "10px" : "0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="tour-title"
          >
            <h4
              style={{
                color: "#fff",
                fontSize: "18px",
                fontWeight: "700",
                lineHeight: "22px",
                marginBottom: "12px",
              }}
            >
              {t("tour.thirdStepTitle")}
            </h4>
          </div>
          <p
            style={{
              color: "#fff",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              marginBottom: "16px",
            }}
          >
            {t("tour.thirdStepOverviewText")}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p
              style={{
                color: "#fff",
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "17px",
              }}
            >
              {t("stepText", {currentStep: 3, endStep: 3, ns: "common"})}
            </p>
            <div
              style={{
                display: "flex",
              }}
            >
              <button
                className="tour-prev"
                style={{
                  background: "#00508E",
                  padding: "8px 32px",
                  borderRadius: "5px",
                  fontSize: "14px",
                  display: "block",
                  cursor: "pointer",
                  border: "0",
                  color: "#fff",
                  marginRight: i18n.dir() === "rtl" ? "0" : "8px",
                  marginLeft: i18n.dir() === "rtl" ? "8px" : "0",
                }}
                onClick={() => goTo(1)}
              >
                {t("tour.previousButtonLabel")}
              </button>
              <button
                className="tour-next"
                style={{
                  background: "#00508E",
                  padding: "8px 32px",
                  borderRadius: "5px",
                  fontSize: "14px",
                  display: "block",
                  cursor: "pointer",
                  border: "0",
                  color: "#fff",
                }}
                // onClick={() => goTo(3)}
                onClick={() => (window.location.href = "/profile")}
              >
                {t("tour.nextButtonLabel")}
              </button>
            </div>
          </div>
        </div>
      ),
      style: {
        padding: "24px 32px",
        maxWidth: "407px",
        background: "#003F75",
      },
    },
  ];
}
